<template>
  <div id="live-map-controls-sidebar-layers">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeLayersSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">地図のレイヤー</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_LAYERS_SIDEBAR(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>
        <vs-divider class="mb-0" color="#828282"/>
        <vs-collapse>
          <vs-collapse-item>
            <div slot="header" class="header-label" id="map-style-collapse-item-header">
              地図の種類
            </div>
            <map-style />
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import mapStyle from "./items/MapStyle";

// Store
const {
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
} = createNamespacedHelpers("liveMap");

export default {
  components: {
    mapStyle
  },
  data() {
    return {
      init:false,
      vessels: [],
      active: false,
      open: true,
      settings: {
        maxScrollbarLength: 50,
        wheelSpeed: 0.6
      }
    };
  },
  props: {
    map: Object
  },
  watch: {
    activeLayersSidebar(val) {
      if (val) {
        this.setActive(val)
        if(!this.init){
          setTimeout(() => {
            this.onClickCollapse()
          }, 500);
          this.init = true
        }
      }
    }
  },
  computed: {
    ...mapStateOfLiveMap({
      activeLayersSidebar: state => state.activeLayersSidebar
    })
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_METOCEAN_INITIAL_DATETIME",
      "SET_ACTIVE_LAYERS_SIDEBAR",
    ]),
    setActive(isActive) {
      this.active = isActive;
    },
    onClickCollapse(){
      document.getElementById('map-style-collapse-item-header').click()
    },
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#live-map-controls-sidebar-layers {
  .vs-collapse-item--header{
    padding-left: 0;
  }

  .vs-collapse {
    padding: 0 20px 20px;
  }

  .vs-collapse-item--content{
    border-radius: 5px;
  }

  .header-label{
    color: #F2F2F2;
  }

  .icon-header {
    color: #F2F2F2;
  }

  .con-content--item{
    background-color: $aisea-blue-gray;
  }

  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1.0;
  }

  .vs-collapse-item--icon-header {
    right: -15px;

    .vs-icon {
      font-size: 2rem;
    }
  }

  .vs-collapse-item {
    border-bottom: 0;
  }

  .vs-collapse-item--icon-header {
    right: -15px;
  }
}
</style>
